<script>
	import { Html, LayerCake, Svg } from "layercake";

	import Line from "./Line.svelte";
	import Area from "./Area.svelte";
	import AxisX from "./AxisX.svelte";
	import Highlight from "./Highlight.svelte";

	import { formatFloat } from "../map/language";
	import { datesStrings, dateLookup } from "../constants";

	export let data;
	export let colorScale;

	const firstDate = datesStrings[0];
	const lastDate = datesStrings[datesStrings.length - 1];

	$: formattedData = data
		? datesStrings
				.map((dateStr) => {
					const value = data[dateStr];
					if (value !== null && value !== undefined) {
						let relValue;

						if (data[firstDate] === 0) {
							relValue = 0;
							if (value > 0) relValue = 100;
							if (value < 0) relValue = -100;
						} else {
							relValue = (100 * value) / data[firstDate] - 100;
						}

						return {
							date: dateLookup[dateStr],
							value: relValue,
						};
					}
				})
				.filter((d) => !!d)
		: [];

	// const frmt = formatFloat({ signed: true, postfix: "%", adaptive: true, decimal: true });
	const frmtNormal = formatFloat({ digits: 0 });
	const frmtDetailed = formatFloat({ digits: 1, adaptive: true, decimal: true });

	$: frmt = data.smallChange ? frmtDetailed : frmtNormal;
</script>

<div class="chart-container">
	<LayerCake padding={{ top: 0, right: 10, bottom: 0, left: 10 }} x="date" y="value" data={formattedData}>
		<Svg>
			<Area {colorScale} />
			<AxisX
				ticks={Object.values(dateLookup)}
				baseline={true}
				formatTick={(t, i) => (i === 0 ? "⌀&nbsp;2016-2020" : "⌀&nbsp;2021-2022")}
			/>
			<Line stroke={"#AAAAAA"} strokeWidth={4} />
		</Svg>
		<Html>
			<Highlight date={dateLookup[firstDate]} format={(d, i) => frmt(data[firstDate])} color={colorScale(0)} />
			<Highlight date={dateLookup[lastDate]} format={(d, i) => frmt(data[lastDate])} color={colorScale(data.change)} />
		</Html>
	</LayerCake>
</div>

<style>
	.chart-container {
		width: 100%;
		height: 44px;
		margin-bottom: 15px;
	}
</style>
